import { Suspense, useCallback } from "react";
import { Canvas } from "@react-three/fiber";
import type { WebGLRenderer } from "three";
import { HeroScene } from "@/components/scenes/HeroScene";
import { CanvasErrorBoundary } from "@/components/CanvasErrorBoundary";

export function Hero() {
  const onCreated = useCallback(({ gl }: { gl: WebGLRenderer }) => {
    const canvas = gl.domElement;
    canvas.addEventListener('webglcontextlost', (e) => { e.preventDefault(); });
    canvas.addEventListener('webglcontextrestored', () => {});
  }, []);

  return (
    <div className="relative w-full h-screen overflow-hidden bg-black">
      <div className="absolute inset-0 z-0">
        <CanvasErrorBoundary>
          <Canvas
            camera={{ position: [0, 0, 5], fov: 75 }}
            dpr={[1, 1.5]}
            gl={{ alpha: false, antialias: false, powerPreference: "high-performance" }}
            style={{ width: "100%", height: "100%" }}
            onCreated={onCreated}
          >
            <Suspense fallback={null}>
              <HeroScene />
            </Suspense>
          </Canvas>
        </CanvasErrorBoundary>
      </div>
    </div>
  );
}
